import {Store,Module,ActionContext} from 'vuex' 
interface PodcastPickerState{
    show:boolean,
    type:number
}
class PodcastPicker implements Module<PodcastPickerState,any>{
    namespaced=true;
    state={
        show:false,
        type:0
    };
    mutations={
        setShow(state:PodcastPickerState,show:boolean){
            state.show=show;
        },
        setType(state:PodcastPickerState,type:number){
            state.type=type;
        },
    };
}
const module=new PodcastPicker();
export default module;